import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrderItemsExpandListTemplate = ({
	fulfillmentOrderItemsExpandListViewStore,
	fulfillmentOrderItemsExpandListViewStore: { tableData, noDataItem, data, loading },
}) => {
	if (loading) return null;
	return (
		<section>
			<BaasicTable
				{...{
					data,
					tableData,
					fulfillmentOrderItemsExpandListViewStore,
					noDataItem,
					showImage: false,
					viewStore: fulfillmentOrderItemsExpandListViewStore,
				}}
				actions={fulfillmentOrderItemsExpandListViewStore}
			/>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(FulfillmentOrderItemsExpandListTemplate);
